import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]


export default {
  __name: 'BookingErrorActions',
  props: {
	isLoading: { type: Boolean, default: false },
},
  emits: ["close", "resolve"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-secondary",
      disabled: __props.isLoading,
      onClick: _cache[0] || (_cache[0] = $event => (emit('close')))
    }, " Abbrechen ", 8 /* PROPS */, _hoisted_1),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-primary",
      disabled: __props.isLoading,
      onClick: _cache[1] || (_cache[1] = $event => (emit('resolve')))
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("i", { class: "fas fa-arrow-left me-2" }, null, -1 /* CACHED */),
      _createTextVNode(" Konfiguration ändern ", -1 /* CACHED */)
    ]))], 8 /* PROPS */, _hoisted_2)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}